import { SearchResult } from './SearchResult';

export type CrawlRuleScope = 'PATH_PREFIX' | 'EXACT_PAGE';

export type CrawlRunStatus =
  | 'PENDING'
  | 'RUNNING'
  | 'SUCCEEDED'
  | 'FAILED'
  | 'CANCELLED';

export interface CrawlRule {
  scope: CrawlRuleScope;
  value: string;
}

export interface WebsiteSourceResponse {
  id: number;
  seedUrl: string;
  enabled: boolean;
  intervalHours: number;
  nextRunAt: string;
  maxPages: number;
  followDocuments: boolean;
  running: boolean;
  lastRunStatus: CrawlRunStatus | null;
  lastRunFinishedAt: string | null;
  pageCount: number;
  createdDate: string;
  version: number;
  rules: CrawlRule[];
}

export type WebsiteSourceSearchResult = SearchResult<WebsiteSourceResponse>;

export interface WebsiteSourceRequest {
  seedUrl: string;
  intervalHours: number;
  maxPages: number;
  followDocuments: boolean;
  enabled?: boolean;
  rules: CrawlRule[];
  /** The version the edit is based on; required when updating. */
  version?: number;
}

export interface CrawlRunResponse {
  id: number;
  status: CrawlRunStatus;
  createdAt: string;
  startedAt: string | null;
  finishedAt: string | null;
  discovered: number;
  fetched: number;
  created: number;
  changed: number;
  unchanged: number;
  duplicate: number;
  gone: number;
  outOfScope: number;
  thin: number;
  rejected: number;
  errored: number;
  skippedCap: number;
  ownedElsewhere: number;
  retirementBlocked: number;
  changeBlocked: number;
  capped: boolean;
  warning: string | null;
  failureReason: string | null;
}

export const SCHEDULE_PRESETS: { label: string; hours: number }[] = [
  { label: 'Daily', hours: 24 },
  { label: 'Weekly', hours: 168 },
  { label: 'Monthly', hours: 720 }
];

export const EXCLUSION_SCOPE_LABELS: Record<CrawlRuleScope, string> = {
  PATH_PREFIX: 'Path and everything under it',
  EXACT_PAGE: 'Single page'
};

export const EXCLUSION_SCOPE_PLACEHOLDERS: Record<CrawlRuleScope, string> = {
  PATH_PREFIX: '/news/',
  EXACT_PAGE: 'https://www.example.com/page'
};
